import { BridgeComponent } from '@hotwired/hotwire-native-bridge';
import { typeIn } from '../../lib/reader';
import { playSound } from '../../lib/sounds';
import { say } from '../../lib/text';

export default class extends BridgeComponent {
  static component = 'qrscanner';
  static values = {
    endpoint: String,
    mode: String, // 'scan' (default): POST to the endpoint · 'box': type into [data-reader=box]
    // The words, from the view: t('fire.scanner.qr').to_json. Else fire-text.
    messages: Object,
  };

  say(key) {
    return this.messagesValue[key] || say(`scanner.qr.${key}`);
  }

  scan() {
    this.send('scan', {}, ({ data: { value } }) => {
      if (value) {
        this.handleQrData(value);
      } else {
        this.send('scanCallback', { result: false });
        this.showError(this.say('none'));
      }
    });
  }

  async handleQrData(qrCode) {
    try {
      if (this.modeValue !== 'box') {
        // For scan mode, submit directly without form
        const response = await this.fetchData(this.endpointValue || '/scan', { qr_code: qrCode });
        const data = await response.json();

        // The words and who, for a native sheet to draw as it likes: `kind` is the
        // outcome (the screen picks its colour), the rest rides along untouched.
        // `flag` (the reason: dup, date, with_doc…) and `row` (date, CNPJ) are
        // nbe's ScanController#answer: its pane tells a duplicate from a
        // rejection and lists the reads, as the web reader does.
        const { kind, title, tier, name, half, at, count, flag, row } = data;
        this.send('scanCallback', {
          result: data.result && data.valid,
          message: data.message,
          flag,
          row,
          kind,
          title,
          tier,
          name,
          half,
          at,
          count,
        });
        this.updateUI(data);
      } else {
        // box mode: the page's own box and form take the read, the camera closes
        if (typeIn(qrCode)) {
          this.send('scanCallback', { result: true });
          this.send('dismiss');
        } else {
          this.send('scanCallback', { result: false });
          this.showError(this.say('not_found'));
        }
      }
    } catch (error) {
      this.send('scanCallback', { result: false });
      this.showError(this.say('failed'));
    }
  }

  async fetchData(endpoint, data) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify(data),
    });
  }

  updateUI(data) {
    // Clear existing messages
    this.hideMessages();

    console.log('Validity sound playing!', data.sound);
    playSound(data.sound);

    if (data.result && data.valid) {
      // Show success message
      this.showSuccess(data.message || this.say('valid'));

      // If there's tag data, could update some display
      if (data.tag) {
        console.log('Valid tag:', data.tag);
      }
    } else {
      // Show error message
      this.showError(data.message || data.error || this.say('invalid'));
    }
  }

  showSuccess(message) {
    const statusElement = document.getElementById('status-message');
    if (statusElement) {
      const span = statusElement.querySelector('span') || statusElement;
      span.textContent = message;
      statusElement.classList.remove('hidden');
      statusElement.className = 'alert alert-success mb-6';
    }

    // Auto-hide after 3 seconds
    setTimeout(() => this.hideMessages(), 3000);
  }

  showError(message) {
    const errorElement = document.getElementById('error-message') || document.getElementById('status-message');
    if (errorElement) {
      const span = errorElement.querySelector('span') || errorElement;
      span.textContent = message;
      errorElement.classList.remove('hidden');
      errorElement.className = 'alert alert-error mb-6';
    }

    // Auto-hide after 5 seconds
    setTimeout(() => this.hideMessages(), 5000);
  }

  hideMessages() {
    const statusElement = document.getElementById('status-message');
    const errorElement = document.getElementById('error-message');

    if (statusElement) {
      statusElement.classList.add('hidden');
    }

    if (errorElement) {
      errorElement.classList.add('hidden');
    }
  }
}
